import { useEffect, useMemo } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { useProductName } from '@atlassian/jira-tenant-context-controller/src/components/product-name/index.tsx';
import jiraFavicon from './assets/favicon-temp-family.png';
import jpdFavicon from './assets/favicon-temp-jpd.png';
import jsmFavicon from './assets/favicon-temp-jsm.png';
import csmFavicon from './assets/favicon-temp-csm.png';

/**
 * This is a temporary solution for replacing Jira's favicons with the new icons (T25).
 */
export const useFaviconService = __SERVER__
	? () => undefined
	: () => {
			const productName = useProductName();

			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			const iconEle = document.querySelector("link[rel='shortcut icon']");

			// Keep a copy of the default favicon
			const defaultFavicon = useMemo(
				() => (iconEle instanceof HTMLLinkElement ? iconEle.href : ''),
				[iconEle],
			);

			useEffect(() => {
				let faviconPath = jiraFavicon;

				if (productName === 'serviceDesk') {
					faviconPath = jsmFavicon;
				} else if (productName === 'product-discovery') {
					faviconPath = jpdFavicon;
				} else if (productName === 'customer-service') {
					faviconPath = csmFavicon;
				}

				if (iconEle instanceof HTMLLinkElement && fg('blu-7193-new-jira-favicons')) {
					iconEle.href = faviconPath;
				}

				// Switch back to default favicon
				return () => {
					if (iconEle instanceof HTMLLinkElement && fg('blu-7193-new-jira-favicons')) {
						iconEle.href = defaultFavicon;
					}
				};
			}, [productName, defaultFavicon, iconEle]);
		};
